import { ILabel } from "./label";

export enum Paths {
  ArticleData = "/api/kb/v1/getArticleData",
  FullArticleData = "/apic/helpsupport/v1/article"
}
export interface IArticleDataReqParams {
  kb: string;
  id: string;
  visitorToken?: string;
};

export interface IArticleDataResponse {
  title: string;
  body: string;
  attachments: string;
  attachmentUrls: [];
  likesCount: number;
  titleAndBodyHash: number;
  actions: {};
}

export interface IMetaData {
  metaTitle?: string;
  metaDescription?: string;
  canonicalUrl?: string;
}

export interface IFullArticle extends IMetaData {
  id: string;
  title: string;
  body: string;
  labels: ILabel[];
}

export interface IArticleAPIResponse extends IMetaData {
  id: string;
}

export interface IBold360FullArticleReqParams {
  articleId: string;
}

export interface IArticleWithLabel {
  articleId: IFullArticle["id"];
  labelIds: ILabel["id"][];
}
